import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  props: {
    controlData: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    associationInfo: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    item() {
      return this.controlData;
    }
  },
  data() {
    return {
      validateStatus: false,
      rules: {},
      numberLimit: '0,2',
      min: 0,
      max: 0
    };
  },
  created() {
    // this.init();
  },
  mounted() {
    this.associationChange();
  },
  methods: {
    blurFun() {
      this.$emit('valueChange', this.item.mark);
    },
    changeCli() {
      this.$set(this.item, 'value', this.formData[this.item.mark]);
      this.associationChange();
      this.item.controlValue.forEach(item => {
        if (!this.formData[this.item.mark].includes(item.name)) {
          item.showInput = false;
          item.emptyValue = '';
        }
      });
    },
    associationChange() {
      //如果有关联控件，判断是否显示
      let currentMark = this.item.mark;
      if (this.associationInfo[currentMark]) {
        let associationInfo = this.associationInfo[currentMark];
        associationInfo.forEach(item => {
          let show = false;
          let valueArr = item.value;
          let value = this.formData[currentMark];
          if (Array.isArray(value)) {
            value.forEach(val => {
              if (valueArr.indexOf(val) > -1) {
                show = true;
              }
            });
          } else if (valueArr.indexOf(value) > -1) {
            show = true;
          }
          this.$emit('showControl', show, item.targetKey);
        });
      }
    }
  }
};